import { createUseStyles } from 'react-jss'

import { desktop } from '../../theme'


export default createUseStyles({
  container: {
    position: 'relative',
    zIndex: '3',
    height: '100%',
    paddingTop: '4.6rem',
    paddingBottom: '4.6rem',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    overflow: 'hidden',
  },
  wrapper: {
    position: 'relative',
    zIndex: '2',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    height: '100%',
    paddingLeft: '3rem',
    paddingRight: '3rem',
    '& > *:not(.is-notstaggered)': {
      opacity: 0, // to prevent FOUC
    },
  },
  header: {
    textAlign: 'center',
  },
  logoMain: {
    width: '12rem',
    height: '1.4rem',
    ...desktop({
      width: '16rem',
      height: '2.2rem',
    }),
  },
  background: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: '1',
    overflow: 'hidden',
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'cover',
  },
})
